export default class BonConditionnementSettingsMl {
  landscape: boolean = false;
  condiDateFilter: Date[];
  consoDateFilter: Date[];
  printDetails: boolean = false;
  mode: string;
}
